import React__default from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import { themeGet } from '../../utils/theme-get.js';
import { VerticalPositionProvider } from './context/VerticalPositionContext.js';
import Box from '../Box/Box.js';
import { useCenterY } from './hooks/useCenterY.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const GridAreas = {
  Left: 'left',
  Right: 'right',
  Header: 'head',
  Footer: 'foot'
};

// --------------------------------------------------------
// Root
const RuleBuilderLayout = ({
  children,
  isSplitPane = false,
  sx: sxProps,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(VerticalPositionProvider, null, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      ...sxProps,
      display: 'grid',
      gridTemplateAreas: `"${GridAreas.Header} ${GridAreas.Header}" "${GridAreas.Left} ${GridAreas.Right}" "${GridAreas.Footer} ${GridAreas.Footer}"`,
      gridTemplateColumns: isSplitPane ? '1fr 1fr' : '4fr 6fr'
    }
  }, children));
};
RuleBuilderLayout.displayName = "RuleBuilderLayout"; // --------------------------------------------------------
// LeftPane
const StyledLeftPane = styled(Box).withConfig({
  displayName: "RuleBuilderLayout__StyledLeftPane",
  componentId: "sc-7ds43t-0"
})(["display:flex;flex-basis:100%;background-color:", ";grid-area:", ";", ""], themeGet('colors.elevation.surface.default.[default]'), GridAreas.Left, sx);
/**
 * Left pane for Rule builder layout. Must be rendered inside of a Rule Builder
 */
const LeftPane = ({
  children,
  ...props
}) => {
  const {
    setContainerRef
  } = useCenterY();
  return /*#__PURE__*/React__default.createElement(StyledLeftPane, _extends({}, props, {
    ref: setContainerRef
  }), children);
};
LeftPane.displayName = "LeftPane"; // --------------------------------------------------------
// RightPane
const StyledRightPane = styled(Box).withConfig({
  displayName: "RuleBuilderLayout__StyledRightPane",
  componentId: "sc-7ds43t-1"
})(["background-color:", ";height:100%;grid-area:", ";", ""], themeGet('colors.elevation.surface.default.[default]'), GridAreas.Right, sx);
/**
 * Right pane for Rule builder layout. Must be rendered inside of a Rule Builder
 */
const RightPane = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(StyledRightPane, props, children);
};
RightPane.displayName = "RightPane"; // --------------------------------------------------------
// Header
const StyledHeader = styled(Box).withConfig({
  displayName: "RuleBuilderLayout__StyledHeader",
  componentId: "sc-7ds43t-2"
})(["display:flex;background-color:", ";width:100%;grid-area:", ";@media (min-width:", "){}", ""], themeGet('colors.elevation.surface.default.[default]'), GridAreas.Header, themeGet('breakpoints.2'), sx);
/**
 * Header for Rule builder layout
 */
const Header = ({
  children,
  hidden = false,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(StyledHeader, props, children);
};
Header.displayName = "Header"; // --------------------------------------------------------
// Footer
const StyledFooter = styled(Box).withConfig({
  displayName: "RuleBuilderLayout__StyledFooter",
  componentId: "sc-7ds43t-3"
})(["display:flex;background-color:", ";width:100%;grid-area:", ";@media (min-width:", "){}", ""], themeGet('colors.elevation.surface.default.[default]'), GridAreas.Footer, themeGet('breakpoints.2'), sx);
/**
 * Footer for a RuleBuilder Layout. Must be rendered inside of a Rule Builder
 */
const Footer = ({
  children,
  hidden = false,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(StyledFooter, props, children);
};
Footer.displayName = "Footer";
RuleBuilderLayout.displayName = 'RuleBuilderLayout';
var RuleBuilderLayout$1 = Object.assign(RuleBuilderLayout, {
  Header,
  LeftPane,
  RightPane,
  Footer,
  GridAreas
});

export { RuleBuilderLayout$1 as default };
